import React from 'react';
import { useState } from 'react';
import cn from 'classnames';
import type { IFilterButton } from '@/creditflowresearch/ui/common/components/organisms/ButtonGroup';

import styles from './ColorizedPanel.module.scss';

export interface IPanelControls {
  setStyle: (item: IFilterButton) => void,
}

export interface IColorizedPanelProps {
  children?: ((controls: IPanelControls) => React.ReactNode) | React.ReactNode,
  style?: React.CSSProperties,
  isFullWidth?: boolean,
}

const ColorizedPanel = ({
  children,
  style: propStyle,
  isFullWidth = true,
}: IColorizedPanelProps) => {
  const [overrideStyle, setOverrideStyle] = useState<React.CSSProperties | null>(null);

  const setInlineStyles = (item: IFilterButton) => {
    if (item.inlineStyles) {
      setOverrideStyle(item.inlineStyles);
    }
  };

  const panelControls: IPanelControls = {
    setStyle: setInlineStyles,
  };

  const style = overrideStyle || propStyle;

  return (
    <div className={ cn({ [styles.fullWidth]: isFullWidth }) } style={ style }>
      { typeof children === 'function' ? children(panelControls) : children }
    </div>
  );
};

export default ColorizedPanel;
